import { render } from "./JFlose.vue?vue&type=template&id=3cbcd53c&scoped=true"
import script from "./JFlose.vue?vue&type=script&lang=js"
export * from "./JFlose.vue?vue&type=script&lang=js"

import "./JFlose.vue?vue&type=style&index=0&id=3cbcd53c&lang=scss&scoped=true"
import "./JFlose.vue?vue&type=style&index=1&id=3cbcd53c&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbcd53c"]])

export default __exports__